import React from "react";
import { Card, Row, Col } from "react-bootstrap";
import "bootstrap-icons/font/bootstrap-icons.css";
import '../css/main.css';

const DashboardStatus = ({ stats }) => {
  const cards = [
    {
      label: "Uploaded",
      value: stats.uploaded,
      icon: "bi-upload",
      bg: "#686faf",
      iconColor: "#686faf", // white
    },
    {
      label: "Processing",
      value: stats.processing,
      icon: "bi-hourglass-split",
      bg: "#c14006",
      iconColor: "#c14006", // dark gray/black
    },
    {
      label: "Published",
      value: stats.published,
      icon: "bi-check-circle-fill",
      bg: "#019988",
      iconColor: "#019988", // white
    },
    {
      label: "Corrupted",
      value: stats.corrupted,
      icon: "bi-exclamation-triangle-fill",
      bg: "#c98620",
      iconColor: "#c98620", // white
    },
  ];

  return (

    // <Row className="mb-3 g-3" role="region" aria-label="Dashboard statistics" >
    //   {cards.map((card, idx) => (
    //     <Col key={idx} md={3} sm={6} xs={12}>
    //       <Card
    //         className="shadow-sm border-0 text-white h-100"
    //         style={{
    //           backgroundColor: card.bg,
    //           borderRadius: "0.8rem",
    //         }}
    //          role="group"
    //     aria-labelledby={`card-title-${idx}`}
    //     aria-describedby={`card-desc-${idx}`}
    //       >
    //         <Card.Body className="d-flex justify-content-between align-items-center p-4"
    //         tabIndex="0" // allows keyboard focus
    //         >
    //           {/* Left Side */}
    //           <div className="text-start">
    //             {/* This div announces live updates */}
    //             <div  id={`card-title-${idx}`} 
    //             className="fw-bold fs-3" 
    //             aria-live="polite"
    //             aria-atomic="true"
    //              aria-label={`${card.label} 
    //              count ${card.value}`}>
    //               {card.value}
    //               </div>
    //             <div id={`card-desc-${idx}`}
    //               style={{
    //                 fontSize: "0.9rem",
    //                 fontWeight: 500,
    //                 letterSpacing: "0.5px",
    //                 // textTransform: "uppercase",
    //               }}
    //                aria-hidden="false"
    //             >
    //               {card.label}
    //             </div>
    //           </div>

    //           {/* Right Side Icon */}
    //           <div
    //             style={{
    //               backgroundColor: "#f8f9fa",
    //               borderRadius: "50%",
    //               width: "55px",
    //               height: "55px",
    //               display: "flex",
    //               alignItems: "center",
    //               justifyContent: "center",
    //             }}
    //              aria-hidden="true"
    //           >
    //             <i
    //               className={`bi ${card.icon} fs-3`}
    //               style={{ color: card.iconColor }}
    //              aria-hidden="true" // icons are decorative
    //             ></i>
    //           </div>
    //         </Card.Body>
    //       </Card>
    //     </Col>
    //   ))}
    // </Row>
   
    //  <Row className="mb-3 g-3">
    //   {cards.map((card, idx) => (
    //     <Col xs={6} md={3} key={idx}>
    //       <Card
    //         className="text-center shadow-sm border-0"
    //         style={{
    //           backgroundColor: card.bg,
    //           color: "#fff",
    //           borderRadius: "0.8rem",
    //         }}
    //       >
    //         <Card.Body className="p-2">
    //           <Card.Title
    //             className="fs-6 mb-0 fw-bold"
    //             aria-live="polite"
    //             aria-atomic="true"
    //           >
    //             {card.value}
    //           </Card.Title>
    //           <small>{card.label}</small>
    //         </Card.Body>
    //       </Card>
    //     </Col>
    //   ))}
    // </Row>

     <Row className="g-3" role="list" aria-label="Dashboard statistics">
      {cards.map((card, idx) => (
        <Col xs={12} sm={6} md={3} key={idx}>
          <Card
            className="border-0 shadow-sm text-white"
            style={{
              backgroundColor: card.bg,
              borderRadius: "12px",
            }}
             role="listitem"
        aria-label={`${card.label}: ${card.value}`}
        tabIndex={0}
          >
            <Card.Body className="d-flex justify-content-between align-items-center p-2">
              {/* <div>
                <h5 className="fw-bold mb-1">{card.value}</h5>
                <small>{card.label}</small>
              </div> */}
          <div>
            {/* Screen reader will read this via aria-label */}
            <h5 className="fw-bold mb-1" aria-hidden="true">
              {card.value}
            </h5>
            <small aria-hidden="true">{card.label}</small>
          </div>


              <div
                className="d-flex justify-content-center align-items-center"
                style={{
                  background: "white",
                  color: card.bg,
                  borderRadius: "50%",
                  width: "40px",
                  height: "40px",
                }}
                aria-hidden="true"
              >
                <i className={`${card.icon} fs-5`}></i>
              </div>
            </Card.Body>
          </Card>
        </Col>
      ))}
    </Row>

  );
};

export default DashboardStatus;
